import {
  sortDestinationIdFormat,
  stationProcessingSessionIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

const BindSortingToteByScanResult_ = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("ok"),
    toteName: z.string(),
    destinationName: z.string(),
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
  }),
  z.object({ status: z.literal("unrecognized") }),
  z.object({ status: z.literal("blocked"), reason: z.string() }),
]);
export type BindSortingToteByScanResult = z.infer<
  typeof BindSortingToteByScanResult_
>;

export const bindSortingToteByScan = {
  name: "bindSortingToteByScan" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    scannedTote: z.string().min(1),
    sortDestinationId: sortDestinationIdFormat.schema,
  }),
  output: z.object({ result: BindSortingToteByScanResult_ }),
};
